export default "__VITE_ASSET__mPm8qzar__"